module.exports = __webpack_public_path__ + "static/p3-ba1f18eff13b5be645dee73d9a7cf2e5.jpg";